import { Mic, Volume2 } from 'lucide-react';

export default function VoiceHidden({ transcript, status, taskState }) {
  return (
    <div className="flex flex-col items-center z-10 gap-4 w-full max-w-2xl">
      <h2 className="text-2xl md:text-3xl font-semibold text-muted-foreground text-center z-10 max-w-3xl min-h-[60px] flex items-center">
        В точности повторите предложение
      </h2>
      {status === 'speaking' && <Volume2 className="size-12 text-accent animate-pulse" />}
      {status === 'listening' && (
        <div className="flex flex-col items-center gap-4 w-full">
          <Mic className="size-12 text-red-500 animate-bounce" />
          <div className="px-8 py-6 bg-secondary rounded-3xl border-2 border-red-500/30 text-center min-h-[120px] flex items-center justify-center w-full">
            <span className="text-3xl text-primary font-medium">{taskState.accumulated || transcript || "Повторите фразу..."}</span>
          </div>
        </div>
      )}
    </div>
  );
}